// extracted by mini-css-extract-plugin
module.exports = {"imgMinified":"ProductGallery_imgMinified__iGDbz","largeImg":"ProductGallery_largeImg__1uqx5"};